export function hereParams(hereData, loadParams) {
    // let city = [loadParams.deliveryAddress,loadParams.pickupAddress]
    let point = loadParams.dispatchStopPointList ? loadParams.dispatchStopPointList.map(item => {
        return item.address
    }) : []
    let city = [loadParams.pickupAddress, ...point, loadParams.deliveryAddress]
    return {
        truckModel: {},
        sendToUserId: 0,
        routingMode: 'truck',
        routingOption: {
            difficultTurns: true,
            dirtRoad: true,
            toll:false,
            tunnel:false
        },
        shape: hereData.v1Shape,
        waypoint: hereData.waypoint.map((item, index) => {
            return {
                mappedPosition: item.mappedPosition,
                originalPosition: item.originalPosition,
                shapeIndex: item.v1ShapeIndex,
                mappedRoadName: city[index],
                timezone: 'EST'
            }
        }),
        leg: hereData.sections.map(sections => {
            return {maneuver : sections.routeShape.map(x => {
                return {position: { latitude: x[0], longitude: x[1] }}
            })}
        }),
        routeShape2: hereData.sections.map(sections => sections.routeShape2),
    }
}

export function calculateShape(route) {
    const shapes = route.shape || []
    let positions = []
    for (let i = 0; i < shapes.length; i++) {
      positions.push({ lat: shapes[i][0], lng: shapes[i][1] })
    }
    return positions
  }
